<template>
  <div id="GoTop" @click="GoTop()" class="hidden-xs">
    <img class="top-icon" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/cn-assets/new-images/back-top.png" />
    Top
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
#GoTop {
  position: fixed;
  right: 10px;
  bottom: 200px;
  z-index: 99999999;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #162A52;
  color: #162A52;
  font-weight: bold;
  font-size: 14px;
  padding: 8px;
}

.top-icon {
  width: 26px;
  height: 15px;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue